export default __webpack_public_path__ + "static/media/flow.c886d0df.png";